<template>
  <div class="b2c_cost_performance_heat">
    <h3 class="title">热度</h3>
    <ul class="heat_wrap">
      <li v-if="Number.isInteger(popularity.visitCount)">
        <div class="num">
          <span class="num-sum">{{ popularity.visitCount }}</span
          >人
        </div>
        <p>浏览人数</p>
      </li>
      <li v-if="Number.isInteger(popularity.purchasedCount)" class="add_cart_num">
        <div class="num">
          <span class="num-sum">{{ popularity.purchasedCount }}</span
          >人
        </div>
        <p>加购人数</p>
      </li>
      <li v-if="Number.isInteger(popularity.collectionCount)">
        <div class="num">
          <span class="num-sum">{{ popularity.collectionCount }}</span
          >人
        </div>
        <p>收藏人数</p>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      popularity: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
  }
</script>

<style lang="scss">
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
  .b2c_cost_performance_heat {
    height: 226px;

    .heat_wrap {
      display: flex;
      padding: 10px 0 50px;
      align-items: center;
      box-sizing: border-box;
      justify-content: space-around;

      & > li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #999999;
        height: 60px;
        font-size: 20px;
        flex: 1;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        position: relative;

        .num {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          margin-bottom: -6px;
          display: flex;
          align-items: center;
        }

        .num-sum {
          font-size: 36px;
        }

        &:not(:last-of-type) {
          &::after {
            @include hairline(#f0f0f0);
            border-right-width: 1px;
          }
        }
      }
    }
  }
</style>
